const apiVersion = 'v1'

export const BASE_CLIENT_EXECUTIONS_PATH = `api/${apiVersion}/clients/:client_session_id/executions/`
export const BASE_PATH = `api/${apiVersion}/executions/`
